export default __webpack_public_path__ + "static/media/menuL_on_icon_01.b3aca176.png";